import React, { useEffect, useState } from 'react';

const useProtectedRouteHook = () => {
  const [user, setuser] = useState(JSON.parse(localStorage.getItem('user')));
  const [isSales, setisSales] = useState();
  const [isadmin, setadmin] = useState();
  const [isteamleader, setisteamleader] = useState();
  const [isManagers, setisManagers] = useState();
  const [isAccountant, setisAccountant] = useState();

  // const[isteamleader,setisteamleader]=useState()
  // const[ismanager,setismanager]=useState()
  // const[ismarketer,setismarketer]=useState()
  // const[isaccountant,setisaccountant]=useState()
  // console.log(user,"role")

  useEffect(() => {
    if (user != null) {
      if (user.data.role === 'Sales') {
        setadmin(false);
        setisteamleader(false);
        setisManagers(false);
        setisAccountant(false);
        setisSales(true);
      } else if (user.data.role === 'Team Leader') {
        setadmin(false);
        setisSales(false);
        setisManagers(false);
        setisAccountant(false);
        setisteamleader(true);
      } else if (user.data.role === 'Admin') {
        setisteamleader(false);
        setisSales(false);
        setisManagers(false);
        setisAccountant(false);
        setadmin(true);
      } else if (user.data.role === 'Manager') {
        setadmin(false);
        setisteamleader(false);
        setisSales(false);
        setisAccountant(false);
        setisManagers(true);
      } else if (user.data.role === 'Accountant') {
        setadmin(false);
        setisteamleader(false);
        setisSales(false);
        setisManagers(false);
        setisAccountant(true);
      }
    } else {
      setadmin(false);
      setisSales(false);
      setisteamleader(false);
      setisManagers(false);
      setisAccountant(false);
    }
  }, []);

  return [user, isSales, isadmin, isteamleader, isManagers, isAccountant];
};

export default useProtectedRouteHook;
